import { type BillingCustomer, type Plan } from '../../models/Plan'
import { selectAccountId } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'
import { useGetBillingCustomerQuery, useGetPlansQuery } from '../../store/plan/plan'

export interface BillingPlan {
  accountId: string
  customer?: BillingCustomer
  plan?: Plan
  isFetching: boolean
}

export const useBillingPlan = (skip = false): BillingPlan => {
  const accountId = useAppSelector(selectAccountId)
  const { data: customerData, isFetching: customerFetching } = useGetBillingCustomerQuery({ accountId }, { refetchOnMountOrArgChange: true, skip })
  const { data: plansData, isFetching: plansFetching } = useGetPlansQuery(undefined, { skip })

  const customer = customerData?.data
  const plan = plansData?.data.find((candidate) => candidate.id === customer?.subscription?.planId)

  return { accountId, customer, plan, isFetching: customerFetching || plansFetching }
}
